import { Bars3Icon } from "@heroicons/react/24/outline";
import { ProfileMenu } from "./ProfileMenu";
import { NotificationMenu } from "./NotificationMenu";

export function Navbar({ setSidebarOpen }) {
  return (
    <div className="sticky top-0 z-10 flex h-20 items-center gap-x-5 border-b border-gray-200 bg-white/80 backdrop-blur-sm px-4 shadow-md/5 sm:px-6 lg:px-8">
      {/* Sidebar toggle (mobile) */}
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-600 hover:text-blue-600 transition-colors lg:hidden"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>

      {/* Separator */}
      <div className="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true" />

      {/* Right section */}
      <div className="flex flex-1 justify-end items-center gap-x-5 lg:gap-x-6">
        {/* Notifications */}
        <div className="relative">
          <NotificationMenu />
        </div>

        {/* Separator */}
        <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" />

        {/* Profile dropdown */}
        <ProfileMenu />
      </div>
    </div>
  );
}